import React, { Component } from 'react';

//import html parser
import ReactHtmlParser from 'react-html-parser';

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";


/*
    parameters:

    className => class styling
    text => text value can include \n

*/

//splits text using \n into different lines
class HtmlTextBlock extends Component {
    
    constructor(props) {
        super(props);
    }

    render() { 
        return ( 
            <React.Fragment>
                <span className={(!isEmpty(this.props.className) ? this.props.className : "")}>
                    {ReactHtmlParser(this.props.text)}
                </span>
            </React.Fragment>
        );
    }
}
 
export default HtmlTextBlock;